export default __webpack_public_path__ + "static/icon-text-logo-52fa7529d43c3b5b42dbb17b380db5b2.svg";